<template>
	<div class="" style="background: #f1f1f1;">
		<!--头部-->
		<Header @toggleLang="toggleLang"></Header>
		<div class="m-newDetail">
			<div class="detail_cont">
				<div>
					<img class="list_img" :src="zidiyiData.news_center.files" />
				</div>

				<div class="cont_info" >
					<el-row :gutter="30">
						<el-col :span="19">
							<div class="info_left">
								<div class="left_tit">{{lang=='CN' ?content.cn_title:content.en_title}}</div>
								<div class="left_time_look">
									<span class="commo_span">{{content.publishtime_text}}</span>
									<span class="commo_span">
										<img src="@/assets/news/eye.svg" />
										<span>{{content.view}}</span>
									</span>
									<span class="commo_span">
										<img src="@/assets/news/comment.svg" />
										<span>{{content.comment_num}}</span>
									</span>
									<div class="n-news-voice">
										<div class="audio-ctrl-btn pointer" @click="play">语音阅读</div>
										<div class="audio-ctrl-btn pointer" @click="stop">停止</div>
										<!-- <div class="audio-ctrl-btn pointer" @click="cancel">取消</div> -->
									</div>
								</div>
								<video v-if="content.video" :src="content.video" height="500" width="900"
									style=" margin-top: 30px;" controls="controls" :poster="content.image"></video>
								<div class="info_detail" v-html="lang=='CN' ?content.cn_content:content.en_content">
								</div>
								<div class="share">
									<span> {{lang=='CN' ?'分享到':'Share To'}}:</span>
									<img class="pointer" @click="shareToRoom()" src="@/assets/news/zone.png" />
									<img class="pointer" @click="shareToQQ()" src="@/assets/news/qqicon.png" />
									<img class="pointer" @click="shareToMicroblog()" src="@/assets/news/weibo.png" />
								</div>
								<div class="" v-if="content.is_comment">
									<div class="shuru_input">
										<el-input type="textarea" :rows="2"
											:placeholder="lang=='CN' ?'说两句吧':'Say something...'" v-model="textarea">
										</el-input>
										<div class="reat_btn" @click="send">
											{{lang=='CN' ?'发布评论':'Comment'}}
										</div>
									</div>
									<div class="rate_info">
										<div class="rate_tit">
											<span>{{lang=='CN' ?'全部评论':'All Comment'}}</span>
											<el-divider direction="vertical"></el-divider>
											<span>{{comTotal}}条</span>
										</div>
										<div class="rate_neirong" v-for="(item,index) in comList">
											<div class="rate_time">
												<span>{{lang=='CN' ?'访问客户':'Trator'}}</span>
												<span>{{item.createtime | formatDate}}</span>
											</div>
											<div class="rate_cont">
												{{item.comment}}
											</div>
											<div class="rate_footer">
												<!-- <span>赞1212</span> -->
												<!-- <span>回复</span> -->
											</div>
										</div>
									</div>
								</div>
							</div>

						</el-col>
						<el-col :span="5">
							<div class="info_right">
								<div class="right_tit text-uppercase">{{lang=='CN' ?'热点聚焦':'hot topic'}}</div>
								<div class="right_info">
									<div class="wrap" v-for="(item,index) in arcList" v-if="index<3">
										<div class="youDetail" v-if="index==0">
											<img :src="item.image" />
											<span>{{item.author}}</span>
										</div>
										<div class="youDetailList" @click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)" >
											<span class="tit_span line-2">{{lang=='CN' ?item.cn_title:item.en_title}}</span>
											<div class="goDetailBtn">
												<span>{{item.publishtime_text}}</span>
												<span
													class="btn_square css3"><em>{{lang=='CN' ?'了解详情':'Find out details'}}</em></span>
											</div>
										</div>
									</div>
									<div class="more_btn btn_square" @click.stop="go_hotList">
										<em data-v-957c9522="">查看更多 MOER</em><span data-v-957c9522=""></span>
									</div>
								</div>


							</div>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import moment from 'moment'
	import Header from '@/components/Header'
	import Footer from '@/components/Footer'


	import {
		archives_list
	} from '@/api/api.js'
	export default {
		components: {
			Header,
			Footer
		},
		name: 'new_detail',
		data() {
			return {
				textarea: '',
				id: '',
				content: {},
				arcList: [],
				total: '',
				orientalList: [], //内容列表
				company_id: 1, //公司ID
				commentList: [],
				per_page: 9,
				page: 1,
				zidiyiData: {
					news_center: {
						files: ''
					}
				},
				comTotal: '',
				comList: [],
				lang: localStorage.getItem('lang') || 'CN',
				Audio: '',
				isFixed: false,
			}
		},
		filters: {
			formatDate: function(value) {
				return moment(value * 1000).format('YYYY-MM-DD')
			}
		},

		created() {
			this.id = this.$route.query.id
			this.company_id = this.$route.query.id
			this.detail(this.id)
			this.getZidiyiData();
			this.getCommentList()
			let data = {
				channel_id: '',
				per_page: this.per_page,
				page: this.page,
				flag: 'hot'
			}
			archives_list(data).then((res) => {
				if (res.code == 1) {
					this.arcList = res.data.data
					this.total = res.data.total
				}
			}).catch(err => {});
			this.addLocatPath()
		},
		mounted() {
			if (this.id == 123) {
				this.getArchivesList(159)
			}


			window.addEventListener('scroll', this.handleScroll) // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
		},
		methods: {
			handleScroll() { //滚动事件
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body
					.scrollTop // 滚动条偏移量
				// let offsetTop = document.querySelector('.n-news-voice').offsetTop;  // 要滚动到顶部吸附的元素的偏移量
				let offsetTop = 700; // 要滚动到顶部吸附的元素的偏移量
				this.isFixed = scrollTop > offsetTop ? true : false; // 如果滚动到顶部了，this.isFixed就为true
				if (this.isFixed) {
					$(".n-news-voice").addClass("fixednav");
				} else {
					$(".n-news-voice").removeClass("fixednav");
				}
			},
			play() { //播放阅读
				var word = document.getElementsByClassName('info_detail')[0].innerText
				/**
				 * 	文档 https://ai.baidu.com/ai-doc/SPEECH/Qk38y8lrl
				 * 	百度  语音合成接口支持 POST 和 GET两种方式， 推荐POST方式请求。 正式地址：http://tsn.baidu.com/text2audio 或 、https://tsn.baidu.com/text2audio
				 *  	cuid:用户唯一标识，用来计算UV值。建议填写能区分用户的机器 MAC 地址或 IMEI 码，长度为60字符以内
				 * 	ctp:客户端类型选择，web端填写固定值1
				 *	lan:固定值zh。语言选择,目前只有中英文混合模式，填写固定值zh
				 * 	spd:语速，取值0-15，默认为5中语速
				 * 	pit:音调，取值0-15，默认为5中语调
				 * 	vol:音量，取值0-15，默认为5中音量（取值为0时为音量最小值，并非为无声）
				 * 	per:度小宇=1，度小美=0，度逍遥（基础）=3，度丫丫=4;度逍遥（精品）=5003，度小鹿=5118，度博文=106，度小童=110，度小萌=111，度米朵=103，度小娇=5
				 * 	tex:合成的文本，使用UTF-8编码。不超过60个汉字或者字母数字。文本在百度服务器内转换为GBK后，长度必须小于120字节。如需合成更长文本，推荐使用长文本在线合成
				 * */
				// console.log("===",word);
				// console.log("===",word.length);
				if (word.length > 900) {
					word = word.slice(0, 900)
				}
				let url =
					"https://tts.baidu.com/text2audio?cuid=baike&spd=5&lan=ZH&ctp=1&pdt=301&vol=4&rate=32&per=0&tex=" +
					encodeURI(word);
				if (this.Audio != '') {
					this.stop()
				}
				// console.log("===",word.length);
				this.Audio = new Audio(url);
				this.Audio.src = url;
				this.Audio.id = 'Audio';
				this.Audio.controls = true;
				this.Audio.play(); //播放阅读this.Audio
				document.getElementsByClassName('n-news-voice')[0].appendChild(this.Audio)
				return this.Audio

			},
			stop() { // 停止阅读
				if (document.getElementById('Audio')) {
					document.getElementsByClassName('n-news-voice')[0].removeChild(document.getElementById('Audio'))
				}
				this.Audio.pause(true); //停止阅读
				return this.Audio
			},
			toggleLang(str) {
				localStorage.setItem('lang', str)
				this.lang = str
			},
			
			go(id) {
				this.$router.push({
					path: `new_detail?id=${id}`
				})
			},
			go_open(url) {
				if (url) {
					window.open(url, "_blank");
				}
			},
			
			detail(id) {
				let data = {
					id: id
				}

				this.$axios.get("/api/jx/archives_detail", {
					params: data
				}).then((res) => {

					if (res.data.code == 1) {
						this.content = res.data.data
						this.content.cn_content = this.content.cn_content.replace(/\img/g, 'image')
						this.content.cn_content = this.content.cn_content.replace(/data-src/g, 'src')
						this.content.en_content = this.content.en_content.replace(/img/g, 'image')
						this.content.en_content = this.content.en_content.replace(/data-src/g, 'src')
					}
				}).catch(err => {});
				this.id = id
			},
			send() {
				this.push()
			},
			addLocatPath() {
				let data = {
					directions: '新闻详情',
					path: window.location.href
				}

				this.$axios.get("/api/jx/add_pv", {
					params: data
				}).then((res) => {

				}).catch(err => {});
			},
			//更多
			go_list(id) {
				this.$router.push({
					path: `list`,
					query: {
						parent_id: this.parent_id,
						id: id
					}
				})
			},
			getArchivesList(id) {
				let data = {
					channel_id: id,
					per_page: this.per_page,
					page: this.page
				}
				archives_list(data).then((res) => {

					res.data.data.map(e => {

						e.en_cont = e.en_digest ? e.en_digest : this.filtersText(e
							.en_content)
						e.cn_cont = e.cn_digest ? e.cn_digest : this.filtersText(e
							.cn_content)
					})

					this.orientalList = res.data.data
					this.total = res.data.total

				}).catch(err => {});
			},
			filtersText(val) {
				if (val != null && val != '') {
					let reg = /[\u4e00-\u9fa5]/g;
					let names = val.match(reg);
					val = names ? names.join('') : '';
					return val;
				} else return '';
			},
			go(id) {

				this.$router.push({
					path: `new_detail?id=${id}`
				})
				this.id = id
			},
			go_open(url) {
				if (url) {
					window.open(url, "_blank");
				}
			},

			// 获取自定义图片
			getZidiyiData() {
				let data = {
					channel_id: 47,
					per_page: this.per_page,
					page: this.page
				}

				this.$axios.get("/api/jx/get_file_all", {
					params: data
				}).then((res) => {

					this.zidiyiData = res.data.data
				}).catch(err => {});
			},
			push() {
				if (this.textarea.replace(/\s+/g, '') == '') {
					this.$message.error('请输入内容');
					return
				}
				console.log(this.id,888)
				let data = {
					archives_id: this.id,
					comment: this.textarea
				}
				this.$axios.get("/api/jx/add_comment", {
					params: data
				}).then((res) => {

					if (res.data.code == 1) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});
						this.textarea = ''
						this.getCommentList()
					} else {
						this.$message.error(res.data.msg);
					}
				}).catch(err => {});
			},
			getCommentList() {
				let data = {
					archives_id: this.company_id,
					per_page: this.per_page,
					page: this.page
				}
				this.$axios.get("/api/jx/comment_list", {
					params: data
				}).then((res) => {


					this.comTotal = res.data.data.total
					this.comList = res.data.data.data
				}).catch(err => {});
			},
			go_hotList() {
				this.$router.push({
					path: `hot`
				})
			},
			//分享到QQ好友(PC端可用)
			shareToQQ() {
				//此处分享链接内无法携带图片
				const share = {
					title: this.content.cn_title,
					desc: this.content.cn_digest,
					share_url: window.location.href,
				};
				window.open(
					"https://connect.qq.com/widget/shareqq/index.html?url=" +
					encodeURIComponent(share.share_url) +
					"&title=" +
					share.title +
					"&desc=" +
					share.desc
				);
			},
			//分享到QQ空间(可用)
			shareToRoom() {
				//自定义内容
				const share = {
					title: this.content.cn_title,
					desc: this.content.cn_digest,
					image_url: [this.content.image],
					share_url: window.location.href
				};
				let image_urls = share.image_url.map(function(image) {
					return encodeURIComponent(image);
				});
				//跳转地址
				window.open(
					"https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" +
					encodeURIComponent(share.share_url) +
					"&title=" + share.title +
					"&pics=" + image_urls.join("|") +
					"&summary=" + share.desc
				);
			},
			//分享到微博(可用)
			shareToMicroblog() {
				//自定义内容
				const share = {
					title: this.content.cn_title,
					image_url: [this.content.image],
					share_url: window.location.href
				};
				//跳转地址
				// location.replace(
				window.open(
					"https://service.weibo.com/share/share.php?url=" +
					encodeURIComponent(share.share_url) +
					"&title=" + share.title +
					"&pic=" + share.image_url +
					"&searchPic=true"
				);
			},
			//分享到微信(不可用)
			shareToWeChat() {
				//自定义内容
				// return
				const share = {
					title: this.content.cn_title,
					image_url: [this.content.image],
					share_url: window.location.href
				};
				//跳转地址
				window.open(
					"https://zixuephp.net/inc/qrcode_img.php?url=" +
					encodeURIComponent(share.share_url)
				);
			}
		}
	}
</script>

<style lang="scss" scoped>
	textarea {
		min-height: 100px !important;
	}

	h1,
	h2 {
		font-weight: normal;
	}

	ul {
		list-style-type: none;
		padding: 0;
	}

	li {
		display: inline-block;
		margin: 0 10px;
	}

	a {
		color: #42b983;
	}

	.m-newDetail {
		background: #fff;

		.n-news-voice {
			display: flex;
			align-items: center;
		}
	}

	.m-newDetail .detail_cont {
		padding: 30px;
	}

	.m-newDetail .detail_cont .detail_img {
		width: 100%;
	}

	.m-newDetail .cont_info {
		margin: 50px auto;
		width: 1200px;
	}

	.m-newDetail .left_tit {
		font-size: 28px;
		font-weight: bold;
	}

	.m-newDetail .left_time_look {
		margin-top: 30px;
		display: flex;
		align-items: center;
	}

	.m-newDetail .left_time_look img {
		width: 20px;
	}

	.m-newDetail .commo_span {
		margin-right: 50px;

		span {
			margin-left: 5px;
		}
	}

	.m-newDetail .info_detail {
		margin-top: 50px;
		overflow: hidden;
	}


	.info_detail>>>img {
		width: 100% !important;
	}

	.m-newDetail .share {
		margin-top: 60px;
	}

	.m-newDetail .share img {
		width: 30px;
		height: 30px;
		margin-right: 20px;
	}

	.m-newDetail .share img:hover {
		background: none;
	}

	.m-newDetail .share span {
		margin-right: 20px;
	}

	.m-newDetail .shuru_input {
		display: flex;
		margin-top: 60px;
	}

	.el-textarea {
		display: inherit;
	}

	.el-textarea__inner {
		min-height: 100px !important;
	}

	.m-newDetail .shuru_input .reat_btn {
		width: 150px;
		height: 100px;
		background: #f5f5f5;
		text-align: center;
		line-height: 100px;
		font-size: 14px;
		font-weight: bold;
		cursor: pointer;
	}

	.m-newDetail .rate_tit {
		display: flex;
		align-items: center;
		font-size: 12px;
		color: #000;
		padding: 10px 0px;
		border-bottom: 1px solid #dddee4;
	}

	.m-newDetail .rate_info {
		margin-top: 60px;
	}

	.m-newDetail .rate_neirong {
		padding: 30px 0;
		font-size: 12px;
		color: #666;
		/* border-top: 1px solid #dddee4; */
		border-bottom: 1px solid #dddee4;
		margin-top: 10px;
	}

	.m-newDetail .rate_time,
	.rate_cont {
		margin-bottom: 10px;
	}

	.m-newDetail .rate_time {
		display: flex;
		align-items: center;
	}

	.m-newDetail .rate_time span:first-child {
		font-size: 16px;
		font-weight: bold;
		color: #000;
		margin-right: 20px;
	}

	.m-newDetail .rate_footer {
		color: #000;
	}

	.m-newDetail .rate_footer span {
		cursor: pointer;
	}

	.m-newDetail .rate_footer span:first-child {
		margin-right: 30px;
	}

	.m-newDetail .right_tit {
		background: #006170;
		width: 100%;
		height: 50px;
		line-height: 50px;
		text-align: center;
		color: #fff;
		margin-bottom: 10px;

	}

	.m-newDetail .right_info {
		overflow: hidden;
	}

	.m-newDetail .right_info .wrap {
		overflow: hidden;
	}

	.m-newDetail .youDetail {
		display: flex;
		flex-direction: column;
		padding: 0 0 20px;
		border-bottom: 1px solid #eee;
		cursor: pointer;
	}

	.m-newDetail .youDetail img {
		width: 100%;
		height: 150px;
	}

	.m-newDetail .youDetail span {
		margin-top: 20px;
		margin-left: 10px;
	}

	.m-newDetail .youDetail:last-child {
		border-bottom: none;
	}

	.m-newDetail .youDetailList {
		cursor: pointer;
		padding: 40px 10px 40px 10px;
		border-bottom: 1px solid #eee;

	}

	.m-newDetail .youDetailList:hover {
		background: #ebf3f5;
	}

	.m-newDetail .tit_span {
		display: block;
		margin-bottom: 10px;
		font-size: 14px;
		height: 60px;
		line-height: 30px;
		color: #333;
	}

	.m-newDetail .goDetailBtn {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-top: 10px;
		font-size: 14px;
		color: #999;
	}

	.m-newDetail .goDetailBtn span:last-child {
		width: 100px;
		height: 25px;
		line-height: 25px;
		text-align: center;
		color: #fff;
		background: #006170;
		cursor: pointer;
	}

	.m-newDetail .more_btn {
		font-size: 14px;
		color: #666;
		height: 50px;
		line-height: 50px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #ebf3f5;
		font-weight: bold;
		cursor: pointer;
		margin-top: 10px;
	}

	.m-newDetail .more_btn span {
		position: relative;
		top: -1px;
		background: url(~@/assets/img/arrows_gray.png) center no-repeat;
	}

	.m-newDetail .more_btn:hover {
		color: #ffffff;

	}


	.m-newDetail .more_btn:hover span {
		color: #ffffff;
		background: url(~@/assets/img/arrows_white.png) center no-repeat;
	}



	.m-newDetail .more_btn img {
		width: 20px;
		height: 20px;
	}

	.m-newDetail .more_btn span:nth-child(2) {
		padding: 0 10px;
	}

	.m-newDetail .el-divider {
		background-color: #000 !important;
	}

	.info_right {
		width: 230px;
	}

	/* 正佳慈善基金会——新闻资讯 GO */
	.pro-news {
		margin-top: 50px;
		position: relative;
		left: 0px;

		.info_tit {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;

			/deep/ .swiper-pagination-bullet {
				display: none;
			}

			.active {
				border: 2px solid #006170;
				box-shadow: 5px 7px 10px #cddadc;
				color: #000;
			}

			.tit_left {
				span:first-child {
					font-size: 30px;
					color: #000;
					font-weight: bold;
				}

				span:last-child {
					font-size: 12px;
					color: #999;
				}
			}
		}

		.liebiao_list {
			margin: 20px 0 0 -30px;

			.liebiao_info {
				width: calc(100% + 60px);
				display: flex;
				flex-direction: row;
				justify-content: flex-start;
				padding: 30px 30px 30px 30px;
				cursor: pointer;
				position: relative;
				left: 0px;

				&:hover {
					background: #f0f4f5;
				}

				&::after {
					width: calc(100% - 60px);
					height: 1px;
					content: '';
					background: #f0f4f5;
					display: block;
					position: absolute;
					bottom: 0px;
				}

				.info_left {
					width: 320px;
					height: 180px;
					margin-right: 0px;

					img {
						width: 320px;
						height: 180px;

					}
				}

				.info_right {
					width: 805px;
					height: 180px;
					margin-left: 40px;
					margin-right: -30px;

					.right_down_div {
						display: flex;
						align-items: center;
					}

					.right_tit1 {
						font-size: 24px;
						color: #000;
					}

					.right_tit1:hover {
						color: #006170;
					}

					.commo_span {
						display: flex;
						align-items: center;
						margin-left: 50px;
					}

					.commo_span img {
						width: 20px;
						margin-right: 5px;
					}

				}

				.jieshao {
					font-size: 14px;
					color: #666666;
					clear: both;
					display: block;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
					margin-bottom: 30px;
					width: 100%;
					margin-top: 40px;
				}

				.jieshao:hover {
					opacity: 0.8;
				}

				.fenye {
					margin-top: 50px;
					text-align: center;
				}

				.el-pagination.is-background .el-pager li:not(.disabled).active {
					background-color: #006170;
				}
			}
		}
	}

	.last {
		margin-top: 30px;
	}
</style>

<style>
	textarea {
		border-radius: 0px !important;
	}
</style>
